import { render, staticRenderFns } from "./RecipesTotal.vue?vue&type=template&id=258459f7"
import script from "./RecipesTotal.vue?vue&type=script&lang=js"
export * from "./RecipesTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports